interface ControlData {
  sensitivity?: number;
  [key: string]: any;
}

interface AltTextData {
  tp: number;
  fn: number;
}

const updateFunc = (controlData: ControlData): AltTextData => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;

  const tp = sensitivity;
  const fn = 100 - sensitivity;
  const calculatedData: AltTextData = {
    tp,
    fn,
  };

  return calculatedData;
};

export default updateFunc;
